import { create } from 'zustand'

let nextId = 1

const useToastStore = create((set) => ({
  toasts: [],

  addToast: ({ type = 'info', message, duration = 4000 }) => {
    const id = nextId++
    set((state) => ({
      toasts: [...state.toasts, { id, type, message }],
    }))
    if (duration > 0) {
      setTimeout(() => {
        set((state) => ({
          toasts: state.toasts.filter((t) => t.id !== id),
        }))
      }, duration)
    }
    return id
  },

  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}))

/** Convenience helpers — import these directly */
export const toast = {
  success: (message, duration) =>
    useToastStore.getState().addToast({ type: 'success', message, duration }),
  error: (message, duration) =>
    useToastStore.getState().addToast({
      type: 'error', message, duration: duration ?? 6000,
    }),
  warning: (message, duration) =>
    useToastStore.getState().addToast({ type: 'warning', message, duration }),
  info: (message, duration) =>
    useToastStore.getState().addToast({ type: 'info', message, duration }),
}

export default useToastStore
